module.exports = __webpack_public_path__ + "static/media/no-team.3cd80330.svg";